import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "app/store";
import { getData, postFile } from "features/dinamic";
import { setLoading } from "features/loader";
import { setVisible } from "features/modal";
import { setDataToast, setVisibleToast } from "features/toast/toastBaseSlice";
import AlertInterface from "features/toast/toastInterface";

interface AlumnoState {
    status: string;
    error: string;
    alumnoList: any[],
    alumno: {
        idUsuario: number | null;
        user: string | null;
        carnet: string | null;
        clave: string | null;
        estado: number | null;
        primerNombre: string | null;
        segundoNombre: string | null;
        tercerNombre: string | null;
        primerApellido: string | null;
        segundoApellido: string | null;
        cui: string | null;
        idGenero: number | null;
        genero: string | null;
        fileImage: string | null;
        fileData: string | null;
        fechaNacimiento: Date | null;
        idDepartamento: number | null;
        departamento: string | null;
        idMunicipio: number | null;
        municipio: string | null;
        direccion: string | null;
        zona: number | null;
        correo: string | null;
        telefonoPrincipal: string | null;
        telefonoSecundario: string | null;
        idGrado: number | null;
        grado: string | null;
        idPromedio: number | null;
        promedio: string | null;
        idTipoCentro: number | null;
        tipoCentro: string | null;
        nombreCentroEducativo: string | null;
        infoEncargadoList: InfoEncargado[];
        idRelacion: number | null;
        relacion: string | null;
        motivoRelacion: string | null;
        idActividadExtra: number | null;
        actividadExtra: string | null;
        motivoActividadExtra: string | null;
        infoIdiomaList: InfoIdioma[];

    }
}

interface InfoEncargado {
    primerNombre: string | null;
    segundoNombre: string | null;
    tercerNombre: string | null;
    primerApellido: string | null;
    segundoApellido: string | null;
    cui: string | null;
    correo: string | null;
    telefonoPrincipal: string | null;
    telefonoSecundario: string | null;
    idParentesco: number | null;
    parentesco: string | null;
    idOcupacion: number | null;
    ocupacion: string | null;
}

interface InfoIdioma {
    idIdioma: number | null;
    nombre: string | null;
}

const initialState: AlumnoState = {
    status: 'idle',
    error: '',
    alumnoList: [],
    alumno: {
        idUsuario: null,
        user: null,
        carnet: null,
        clave: null,
        estado: null,
        primerNombre: null,
        segundoNombre: null,
        tercerNombre: null,
        primerApellido: null,
        segundoApellido: null,
        cui: null,
        idGenero: null,
        genero: null,
        fileImage: null,
        fileData: null,
        fechaNacimiento: null,
        idDepartamento: null,
        departamento: null,
        idMunicipio: null,
        municipio: null,
        direccion: null,
        zona: null,
        correo: null,
        telefonoPrincipal: null,
        telefonoSecundario: null,
        idGrado: null,
        grado: null,
        idPromedio: null,
        promedio: null,
        idTipoCentro: null,
        tipoCentro: null,
        nombreCentroEducativo: null,
        infoEncargadoList: [],
        idRelacion: null,
        relacion: null,
        motivoRelacion: null,
        idActividadExtra: null,
        actividadExtra: null,
        motivoActividadExtra: null,
        infoIdiomaList: []
    }
}

export const fetchAlumno = createAsyncThunk('fetchAlumno', async (_: any, { dispatch, getState, rejectWithValue }) => {
    const idsp = 38;
    const { result, message, data } = await getData({ idsp }, getState, dispatch);
    if (result) {
        return { data };
    }
    return rejectWithValue(message);
});

export const modifyCreateAlumno = createAsyncThunk('modifyCreateAlumno', async (_: any, { dispatch, getState, rejectWithValue }) => {
    const state: any = getState();
    const alumno = selectAlumno(state);
    const alumnoAttributes = { ...alumno }
    const idsp = alumnoAttributes.idUsuario ? 10 : 9;
    let alert: AlertInterface;

    const { result, message, data } = await getData({ idsp, ...alumnoAttributes }, getState, dispatch);
    if (result) {
        alert = { title: 'CORRECTO..!', message: message, data: [], type: 'LimeGreen', time: Date.now() };
        if (alumnoAttributes.fileData != null && alumnoAttributes.fileData !== '') {
            const { result } = await postFile({ idsp: 79, id: data, dir: "alumno", fileData: alumnoAttributes.fileData, fileName: data }, getState, dispatch);
            if (!result) {
                alert = { title: 'ACCIÓN INCOMPLETA', message: "IMAGEN NO SE HA PODIDO GUARDAR", data: [], type: 'Crimson', time: Date.now() };
            }
        }
    }
    else {
        alert = { title: 'ACCIÓN INCOMPLETA', message: message, data: data, type: 'Crimson', time: Date.now() };
    }
    dispatch(setDataToast(alert));
    dispatch(setVisibleToast(true));
    if (result) {
        dispatch(setVisible(false));
    }
    dispatch(setLoading(false));
    setTimeout(() => {
        dispatch(setVisibleToast(false));
    }, 5000);
    dispatch(fetchAlumno({}));
    return rejectWithValue(message);
});

export const updateEstadoAlumno = createAsyncThunk('updateEstadoAlumno', async (_: any, { dispatch, getState, rejectWithValue }) => {
    const state: any = getState();
    const usuarioNew = selectAlumno(state);
    const usuarioAttributes = { ...usuarioNew }
    const estado = !usuarioAttributes.estado;
    const idUsuario = usuarioAttributes.idUsuario;
    const idsp = 7;
    let alert: AlertInterface;

    const { result, message, data } = await getData({ idsp, estado, idUsuario }, getState, dispatch);
    if (result) {
        alert = { title: 'CORRECTO..!', message: message, data: [], type: 'LimeGreen', time: Date.now() };
    }
    else {
        alert = { title: 'ACCIÓN INCOMPLETA', message: message, data: data, type: 'Crimson', time: Date.now() };
    }
    dispatch(setDataToast(alert));
    dispatch(setVisibleToast(true));
    dispatch(setVisible(false));
    dispatch(setLoading(false));
    setTimeout(() => {
        dispatch(setVisibleToast(false));
    }, 4000);
    dispatch(fetchAlumno({}));
    return rejectWithValue(message);
});


export const alumnoSlice = createSlice({
    name: 'alumno',
    initialState,
    reducers: {
        setAlumnoList: (state, action) => {
            state.alumnoList = action.payload;
        },
        setAlumno: (state, action) => {
            state.alumno = !action.payload ? initialState.alumno : action.payload;
        },
    },
    extraReducers(builder) {
        builder
            .addCase(fetchAlumno.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchAlumno.fulfilled, (state, action) => {
                const { data } = action.payload;
                state.status = 'completed';
                state.alumnoList = data ? data : [];

            })
            .addCase(fetchAlumno.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload as string;
            })
            .addCase(modifyCreateAlumno.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(modifyCreateAlumno.fulfilled, (state, action) => {
                state.status = 'completed';

            })
            .addCase(modifyCreateAlumno.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload as string;
            })
    }
})

export const selectAlumnoList = (state: RootState) => state.alumno.alumnoList;
export const selectAlumno = (state: RootState) => state.alumno.alumno;

export const { setAlumnoList, setAlumno } = alumnoSlice.actions;


export default alumnoSlice.reducer;